import { eventHeightMap } from '@cont/PlannerV2/planner-constants';
import BaseCard from '@cont/PlannerV2/PlannerCards/BaseCard';
import QuizHeroIcon from '@cont/PlannerV2/PlannerCards/QuizCard/QuizHeroIcon';
import pushRoute from '@utils/pushRoute';
import { PlannerItemWrapper } from '../PlannerElements';

const QuizCard = ({ metaItem }) => {
  const {
    name,
    activityAt,
    eventType,
    isLive,
    isCancelled,
    isUpcoming,
    hasWatched,
    relativeLink,
    showIcon,
    iconColor,
    info
  } = metaItem;
  const isClickable = !isUpcoming && !isCancelled;
  const handleItemClick = () => {
    if (!isClickable) return;
    pushRoute('/quiz/[quizSlug]/[quizUID]', relativeLink);
  };
  return (
    <PlannerItemWrapper $height={eventHeightMap[eventType]}>
      <BaseCard
        title="Quiz"
        titleColor="var(--color-i-quiz)"
        description={name}
        info={info}
        isLive={isLive}
        isCancelled={isCancelled}
        isUpcoming={isUpcoming}
        isClickable={isClickable}
        hasCompleted={hasWatched}
        activityAt={activityAt}
        item={metaItem}
        showAuthor={false}
        rightIcon={
          showIcon ? <QuizHeroIcon color={iconColor} isLive={isLive} /> : null
        }
        onItemClick={handleItemClick}
      />
    </PlannerItemWrapper>
  );
};

export default QuizCard;
